/// <reference types="@types/google.maps"/>

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}

  sendEvent(
    category: string,
    action: string,
    label?: string,
    value?: string,
    fieldsObject?: { [key: string]: string }
  ) {
    ga('send', 'event', category, action, label, value, fieldsObject);
  }

  setDimension(dimension: string, value: string) {
    ga('set', dimension, value);
  }

  setUserId(userId: string) {
    ga('set', 'userId', userId);
  }
}
